export { CarrucelModule } from './carrucel/carrucel.module';
export { NavbarComponent } from './navbar/navbar.component';
export { FooterComponent } from './footer/footer.component';
export { TitleComponent } from './title/title.component';

export { CardOptionsModule } from './card-options/card-options.module';
